var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.708.563a1.77 1.77 0 1 0 0 3.541 1.77 1.77 0 0 0 0-3.542Zm-1.666 5a.104.104 0 0 0-.105.104V16.5c0 .058.047.104.105.104h3.333a.104.104 0 0 0 .104-.104V5.667a.104.104 0 0 0-.104-.104H1.042Zm5.416 0a.104.104 0 0 0-.104.104V16.5c0 .058.047.104.104.104h3.334a.104.104 0 0 0 .104-.104v-5.833a1.563 1.563 0 0 1 3.125 0V16.5c0 .058.046.104.104.104h3.333a.104.104 0 0 0 .105-.104V9.317c0-2.022-1.76-3.605-3.771-3.422a5.968 5.968 0 0 0-1.807.457l-1.09.466V5.667a.104.104 0 0 0-.103-.104H6.458Z"
  })));
};
export default SvgLinkedin;